var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"loading-text"},[_c('i',{staticClass:"fad fa-spinner fa-spin"}),_vm._v(" Chargement en cours... "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }